import AttributeFiltersPlaceholder from './AttributeFilterResultPlaceholder'
import attributeFilterPlaceholderContainer from './attributeFilterResultPlaceholderContainer'

export default attributeFilterPlaceholderContainer(AttributeFiltersPlaceholder)
